// imports
import { Typography } from '@mui/material';
import { FC } from 'react';

// components
import { Alert } from 'components/common/Alert';
import { ConsentDialog } from 'components/common/ConsentDialog';

// helpers, constant, interfaces
import { CANCEL_SUBSCRIPTION_TEXT, SUBSCRIPTION_CANCELLED_TEXT, WARNING_TEXT } from 'constants/constant';
import { useCancelSubscriptionMutation } from 'generated/graphql';
import { CancelSubscriptionProps } from 'interfaces';

export const CancelSubscription: FC<CancelSubscriptionProps> = ({
  onCanceled,
  subscriptionId,
  open,
  handleClose,
}) => {
  const [cancelSubscription, { loading }] = useCancelSubscriptionMutation({
    onError: (error) => {
      Alert.error(error.message);
      handleClose();
    },
    onCompleted: () => {
      Alert.success(SUBSCRIPTION_CANCELLED_TEXT);
      onCanceled();
    },
  });

  const handleComplete = async () => {
    if (!subscriptionId) {
      return;
    }

    await cancelSubscription({
      variables: {
        cancelSubscriptionInput: {
          id: subscriptionId,
        },
      },
    });
  };

  return (
    <ConsentDialog
      isError
      countDown
      open={open}
      onClose={handleClose}
      onCountDownComplete={handleComplete}
      loading={loading}
      headerText={WARNING_TEXT}>
      <Typography variant="subtitle1" mt={1}>
        {CANCEL_SUBSCRIPTION_TEXT}
      </Typography>
    </ConsentDialog>
  );
};
